import { useMutation, useQuery } from "react-query";
import { deletePartType, getPartTypes } from "../../../queries/part-types";
import { Button, Flex, Input, Space } from "antd";

import Table from "antd/es/table/Table";
import { IPartType } from "@drone-parts.garphild.pro/interfaces";
import PartTypeDetailsTable from "../components/part-type-details-table";
import { AddPartTypeDialog } from "../../../dialogs/add-part-type-dialog";
import { useState } from "react";

function PartTypes() {
  const [addDialogVisible, setAddDialogVisible] = useState<string>('');
  const [newPartTypeDialogVisible, setNewPartTypeDialogVisible] = useState<boolean>(false);
  const [search, setSearch] = useState<string>('');

  const { refetch, data: partTypes } = useQuery<IPartType[] | null>(
    ['partTypes', {}],
    getPartTypes,
  );

  const deletePartTypeMutation = useMutation({
    mutationFn: deletePartType,
    onSuccess: () => {
      refetch();
    }
  });

  const toggleAddDialog = (key: string) => {
    setAddDialogVisible((prevState) => prevState ? '' : key);
  };

  return (
    <>
      <Space>
        <Input.Search
          placeholder="Search"
          onChange={(e) => {
            setSearch(e.target.value);
          }}
        />
        <Button onClick={() => setNewPartTypeDialogVisible(true)}>Add new part type</Button>
      </Space>
      <Table
        columns={[
          {
            title: 'Id',
            dataIndex: 'key',
            key: 'key',
          },
          {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
          },
          {
            title: 'Actions',
            key: 'actions',
            render: (pt: IPartType) => (
              <Flex>
                <Button onClick={() => deletePartTypeMutation.mutate(pt._id)}>Delete</Button>
                <Button onClick={() => toggleAddDialog(pt.key)}>Add</Button>
              </Flex>
            ),
          }
        ]}
        dataSource={partTypes?.filter((pt) => search ? pt.key.toLowerCase().includes(search.toLowerCase()) : true) || []}
        rowKey="_id"
        expandable={{
          expandedRowRender: (pt,  index, indent, expanded) => {
            return (
              expanded && <PartTypeDetailsTable path={[]} partTypes={pt.subcategories || []} key={pt._id} />
            );
          },
          rowExpandable: (record) => {
            return !!record.subcategories?.length;
          },
          // defaultExpandedRowKeys: expandedRowKeys,
          // expandedRowKeys: expandedRowKeys,
          onExpandedRowsChange: (expandedRows) => {
            console.log("expandedRows", expandedRows);
          },
          // onExpand: (expanded, record) => {
            // expandRow(record._id, expanded);
          // }
        }}
      />
      <AddPartTypeDialog
        opened={!!addDialogVisible}
        parentKey={addDialogVisible}
        onToggle={() => toggleAddDialog('')}
        onSelect={() => { refetch(); }}
      />
      {newPartTypeDialogVisible && (
        <AddPartTypeDialog
          opened={true}
          parentKey={null}
          onToggle={() => setNewPartTypeDialogVisible(false)}
          onSelect={() => refetch()}
        />
      )}
    </>
  );
}

export default PartTypes;
